import * as React from 'react';

interface RunSheetInvoiceItemProps {
    showItems: boolean;
    items: ItemList[];
    itemTypes: ItemTypeList[];
    gst: number;
    invoiceItemModalType: number;
    invoiceItem: InvoiceItem;
    chargeCalloutFee: boolean;
    errors: any;
    deleteError(errorName: string): void;
    updateData(invoiceItem: InvoiceItem): void;
    updateChargeCalloutFee(chargeCalloutFee: boolean): void;
}

interface RunsheetInvoiceItems {
    
}

interface InvoiceItem {
    noCalloutInvoiceNotes: string;
    calloutNotes: string;
    invoiceItems: InvoiceItems[];
}

interface InvoiceItems {
    rowIndex: number;
    id: number;
    itemId: number;
    itemTypeId: number;
    scheduleId: number;
    jobQuoteItemId: number;
    rate: number;
    gst: number;
    amount: number;
    description: string;
    active: boolean;
}

interface ItemTypeList {
    id: number;
    name: string;
    chargeGst: boolean;
}

interface ItemList {
    id: number;
    jobQuoteItemId: number;
    name: string;
    chargeGst: boolean;
}

export default class RunsheetInvoiceItemsData extends React.Component<RunSheetInvoiceItemProps, RunsheetInvoiceItems> {
    constructor(props: any) {
        super(props);

        this.state = {
            
        };

    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        if (e.target.value) {
            
        }

        var invoiceItem = this.props.invoiceItem;
        let newInvItem: any = {};
        newInvItem = invoiceItem;
        newInvItem[e.target.name] = e.target.value;

        this.props.updateData(invoiceItem);
    }

    handleChargeCalloutFeeChange = (e: any) => {
        this.props.updateChargeCalloutFee(e.target.checked);
    }

    onCellChange = (e: any, itemIndex: number, isNumeric: boolean) => {
        var invoiceItem = this.props.invoiceItem;
        var invoiceItems = invoiceItem.invoiceItems;
        var invItem = invoiceItems[itemIndex];
        var lastrow = invoiceItems.length - 1 == itemIndex;

        let newInvoiceItem: any = {};
        newInvoiceItem = invItem;
        newInvoiceItem[e.target.name] = isNumeric ? e.target.value * 1 : e.target.value;

        if (e.target.name === "itemId") {
            let value = e.target.value * 1;
            var item = this.props.items.find(it => it.id == value);
            if (item) {
                invItem.jobQuoteItemId = item.jobQuoteItemId;
            }
        }
        else if (e.target.name === "amount") {
            var itemTypeId = invItem.itemTypeId;

            var chargeGst = true;
            //get gst value
            var itemTypeIndex = this.props.itemTypes.findIndex(it => it.id == itemTypeId);
            if (itemTypeIndex >= 0) {
                var itemTypeRow = this.props.itemTypes[itemTypeIndex];
                if (itemTypeRow) {
                    chargeGst = itemTypeRow.chargeGst;
                }
            }

            let value = e.target.value * 1;
            if (chargeGst) {
                var gstToCalc = this.props.gst + 1;
                var rate = value / gstToCalc;
                invItem.rate = Number((Math.round(rate * 100) / 100).toFixed(2));
                var gstAmount = value - rate;
                invItem.gst = Number((Math.round(gstAmount * 100) / 100).toFixed(2));
            } else {
                invItem.rate = Number((Math.round(value * 100) / 100).toFixed(2));
                invItem.gst = 0;
            }
        }

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow) {
            invoiceItems.push({
                rowIndex: invoiceItems.length,
                id: 0,
                rate: 0,
                gst: 0,
                amount: 0,
                description: "",
                itemId: -1,
                itemTypeId: -1,
                jobQuoteItemId: invItem.jobQuoteItemId,
                scheduleId: invItem.scheduleId,
                active: true
            });
        }
        this.props.updateData(invoiceItem);
    }

    deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();
        var invoiceItem = this.props.invoiceItem;
        var invoiceItems = invoiceItem.invoiceItems;
        var invItem = invoiceItems[itemIndex];
        invItem.active = false;
        this.props.updateData(invoiceItem);
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let invoiceItem = this.props.invoiceItem;
        let invoiceItems = invoiceItem.invoiceItems;
        let itemTypes = this.props.itemTypes;
        let items = this.props.items;

        return (
            <div>
                <div className={this.props.invoiceItemModalType == 1 || this.props.invoiceItemModalType == 4 ? "hidden" : ""}>
                    <label className="input-group" htmlFor="chargeCalloutFee">
                        <span className="label">Charge callout fee?</span>
                        <input type='checkbox' className="input-control" id="chargeCalloutFee" name="chargeCalloutFee" checked={this.props.chargeCalloutFee} onChange={(e) => this.handleChargeCalloutFeeChange(e)} />
                    </label>
                </div>
                <div className={this.props.invoiceItemModalType == 2 && !this.props.chargeCalloutFee ? "hidden" : ""}>
                    <table className='table tableColours'>
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th className={this.props.showItems ? "table__text--align" : "hidden"}>Item</th>
                                <th>Type</th>
                                <th>Invoice Description</th>
                                <th className="hidden">Rate</th>
                                <th className="hidden">GST</th>
                                <th>Amount</th>
                                <th></th>
                            </tr>
                        </thead>
                        {invoiceItems.map((item, itemIndex) =>
                            <tbody key={itemIndex}>
                                <tr className={item.active ? "" : "hidden"}>
                                    <td className="hidden">{item.id}</td>
                                    <td className={this.props.showItems ? "table__text--align" : "hidden"}>
                                        <select className="select table__select--size" id="itemId" name="itemId" value={item.itemId} onChange={(e) => this.onCellChange(e, item.rowIndex, true)} >
                                            <option hidden defaultValue="-1"></option>
                                            {items.map(type =>
                                                <option key={type.id} value={type.id}>{type.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <select className="select table__select--size" id="itemTypeId" name="itemTypeId" value={item.itemTypeId} onChange={(e) => this.onCellChange(e, item.rowIndex, true)} >
                                            <option hidden defaultValue="-1"></option>
                                            {itemTypes.map(type =>
                                                <option key={type.id} value={type.id}>{type.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <input type="text" className="form-control" id="description" name="description" value={item.description} onChange={(e) => this.onCellChange(e, item.rowIndex, false)} />
                                    </td>
                                    <td className="hidden">{item.rate}</td>
                                    <td className="hidden">{item.gst}</td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className="form-control input--small" id="amount" name="amount"  value={item.amount} onChange={(e) => this.onCellChange(e, item.rowIndex, true)} />
                                    </td>
                                    <td className="table__text--align">
                                        {item.rowIndex != invoiceItems.length - 1 ?
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, item.rowIndex)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div> : ""
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    {this.props.errors["invoiceItems"] ?
                        (this.props.errors["invoiceItems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <div className={this.props.chargeCalloutFee ? "hidden" : ""}>
                    <label className="input-group--nowrap" htmlFor="noCalloutInvoiceNotes">
                        <span className="label">Why was a callout fee not charged?</span>
                        <textarea className="input allocate__teamnotes" id="noCalloutInvoiceNotes" name="noCalloutInvoiceNotes" value={invoiceItem.noCalloutInvoiceNotes} onChange={(e) => this.handleChange(e)}></textarea>
                    </label>
                    <span className="label errors">{this.props.errors["noCalloutInvoiceNotes"]}</span>
                </div>
                <div className={this.props.invoiceItemModalType == 1 || this.props.invoiceItemModalType == 4 ? "hidden" : ""}>
                    <label className="input-group--nowrap" htmlFor="calloutNotes">
                        <span className="label label-large">Why did job require a callout?</span>
                        <textarea className="input allocate__teamnotes" id="calloutNotes" name="calloutNotes" value={invoiceItem.calloutNotes} onChange={(e) => this.handleChange(e)}></textarea>
                    </label>
                    <span className="label errors">{this.props.errors["calloutNotes"]}</span>
                </div>
                
            </div>
        )
    }

}